// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// ANTD
import Col from 'components/common/Col';
import Row from 'components/common/Row';

const getTitle = step => {
  switch (step) {
  case 1:
    return 'BASIC INFO';
  case 2:
    return 'PRICING & PACKAGES';
  case 3:
    return 'CONTRACT TERMS';
  case 4:
    return 'INVOICES';
  default:
    return 'SCOPE OF WORK';
  }
};

const getHint = step => {
  switch (step) {
  case 1:
    return null;
  case 2:
    return null;
  case 3:
    return 'Review & edit the contract terms below.  If need you to edit pricing, go back to previous step.';
  case 4:
    return null;
  default:
    return null;
  }
};

const Header = styled.h2`
  font-size: 18px;
  text-align: ${p => (p.windowWidth > 780 ? 'left' : 'center')};
`;

const Hint = styled.span`
  font-size: 12px;
  display: inline-block;
  margin-bottom: 6px;
  margin-top: 6px;
`;

const Container = styled(Row)`
  border-bottom: 2px solid #efefef;
  height: ${p => (p.windowWidth > 780 ? '75px' : '85px')};
  padding-bottom: 10px;
`;

const ContractStepHeader = ({ step, totalSteps, windowWidth }) => {
  console.log(windowWidth);
  return (
    <Container windowWidth={windowWidth} justify="flex-start">
      <Col xs={24} md={20}>
        <Header windowWidth={windowWidth}>{getTitle(step)}</Header>
        <Hint>{getHint(step)}</Hint>
      </Col>
      <Col xs={24} md={4}>
        <Header windowWidth={windowWidth}>
          {step} OF {totalSteps}
        </Header>
      </Col>
    </Container>
  );
};

ContractStepHeader.defaultProps = {
  step: 1,
  totalSteps: 4,
};

export default ContractStepHeader;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/ContractStepHeader/index.js